import { useAuth } from 'context/AuthContext'

import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const ProctedRoutes: FC = () => {
    const { decodedAccessToken } = useAuth()

    if (!decodedAccessToken) {
        return <Navigate to="/error" replace />
    }
    return <Outlet />
}

export default ProctedRoutes
